import React from "react";
import { UncontrolledTooltip, FormFeedback } from "reactstrap";

interface ValidationMsgComponentProps {
  inputName?: any;
  errors?: any;
  rules?: any;
  isTooltip?: boolean;
  invalid?: any;
}

const ValidationMsgComponent: React.FC<ValidationMsgComponentProps> = ({
  inputName,
  errors,
  rules,
  isTooltip,
  invalid,
}) => {
  return (
    <>
      {isTooltip ? (
        <UncontrolledTooltip
          autohide={true}
          target={inputName}
          delay={{ show: 0, hide: 10 }}
        >
          {errors?.[inputName]?.type === "custom"
            ? errors?.[inputName].message
            : errors?.[inputName]?.type === "required"
              ? "This field is required"
              : errors?.[inputName]?.type === "minLength"
                ? `Minimum ${rules?.minLength} values required`
                : errors?.[inputName]?.type === "maxLength"
                  ? ` Maximum ${rules?.maxLength} values are allowed`
                  : errors?.[inputName]?.type === "min"
                    ? `Value should be greater than ${rules?.min}`
                    : errors?.[inputName]?.type === "max"
                      ? `Value should be lower than ${rules?.max}`
                      : errors?.[inputName]?.type === "pattern" &&
                        String(rules?.pattern) === String(/^\w+$/)
                        ? "Can only contain alpha numeric characters, _ and spaces"
                        : String(rules?.pattern) === String(/^[0-9]*$/)
                          ? "Only numerical values are allowed!"
                          : String(rules?.pattern) === String(/^[^-\s][A-Za-z\s]*$/)
                            ? "Can only contain alphabet characters and spaces"
                            : String(rules?.pattern) === String(/^\d{1,10}(\.\d{1,4})?$/)
                              ? "Only numerical values are allowed ! Max length should be 10 digits before decimal points and 4 digits after decimal"
                              : String(rules?.pattern) === String(/^[^-\s][A-Za-z0-9()\-\s]*$/)
                                ? "Can only contain alphabet characters, numerical values, dashes - , spaces and ()"
                                : String(rules?.pattern) ===
                                  String(/^\(?(\d{3})\)?(\d{3})?(\d{4})$/)
                                  ? "Can contain ( on start followed by 3 digits, can contain ) after 3 digits followed by 7 digits. Ex - (071)1234567, 0711234567"
                                  : String(rules?.pattern) === String(/^[^-\s][A-Za-z0-9().\-\s]*$/)
                                    ? "Can only contain alphabet characters, numerical values, dashes - , spaces and () and ."
                                    : String(rules?.pattern) === String(/^[^-\s][A-Za-z0-9().&\-\s]*$/)
                                      ? "Can only contain alphabet characters, numerical values, dashes - , spaces and () and & and ."
                                      : String(rules?.pattern) ===
                                        String(/^[^-\s][A-Za-z0-9().,&\-\s\\]*$/)
                                        ? "Can only contain alphabet characters, numerical values, dashes - , spaces and () and & and . and , and /"
                                        : String(rules?.pattern) === String(/^\d{10}$/)
                                          ? "Mobile Number Should be starts from 0 and only have 10 digits"
                                          : String(rules?.pattern) === String(/^\d+$/)
                                            ? "Only Digits(Numbers) are Allowed"
                                            : String(
                                              rules?.pattern === String(/^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/)
                                            )
                                              ? "Please enter Valid Email"
                                              : String(rules?.pattern) ===
                                              String(/^[^-\s][A-Za-z0-9().&\-\s]*$/) &&
                                              "Can only contain alphabet characters, numerical values, dashes - , spaces and () and & and ."}
        </UncontrolledTooltip>
      ) : (
        <FormFeedback>
          {errors?.[inputName]?.type === "custom"
            ? errors?.[inputName].message
            : errors?.[inputName]?.type === "required"
              ? "This field is required"
              : errors?.[inputName]?.type === "minLength"
                ? `Minimum ${rules?.minLength} values required`
                : errors?.[inputName]?.type === "maxLength"
                  ? `Maximum ${rules?.maxLength} values are allowed`
                  : errors?.[inputName]?.type === "min"
                    ? ` Value should be greater than ${rules?.min}`
                    : errors?.[inputName]?.type === "max"
                      ? `Value should be lower than ${rules?.max}`
                      : errors?.[inputName]?.type === "pattern" &&
                        String(rules?.pattern) === String(/^\w+$/)
                        ? "Can only contain alpha numeric characters, _ and spaces"
                        : String(rules?.pattern) === String(/^[0-9]*$/)
                          ? "Only numerical values are allowed!"
                          : String(rules?.pattern) === String(/^[^-\s][A-Za-z\s]*$/)
                            ? "Can only contain alphabet characters and spaces"
                            : String(rules?.pattern) === String(/^\d{1,10}(\.\d{1,4})?$/)
                              ? "Only numerical values are allowed ! Max length should be 10 digits before decimal points and 4 digits after decimal"
                              : String(rules?.pattern) === String(/^[^-\s][A-Za-z0-9()\-\s]*$/)
                                ? "Can only contain alphabet characters, numerical values, dashes - , spaces and ()"
                                : String(rules?.pattern) ===
                                  String(/^\(?(\d{3})\)?(\d{3})?(\d{4})$/)
                                  ? "Can contain ( on start followed by 3 digits, can contain ) after 3 digits followed by 7 digits. Ex - (071)1234567, 0711234567"
                                  : String(rules?.pattern) === String(/^[^-\s][A-Za-z0-9().\-\s]*$/)
                                    ? "Can only contain alphabet characters, numerical values, dashes - , spaces and () and ."
                                    : String(
                                      // eslint-disable-next-line no-useless-escape
                                      rules?.pattern === String(/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/)
                                    )
                                      ? "Not a Valid Email"
                                      : String(rules?.pattern) ===
                                      String(/^[^-\s][A-Za-z0-9().&\-\s]*$/) &&
                                      "Can only contain alphabet characters, numerical values, dashes - , spaces and () and & and ."}
        </FormFeedback>
      )}
    </>
  );
};

export default ValidationMsgComponent;
